const salesAttendance = [{
  desc: '考勤列表',
  options: {
    url: '/salesAttendance/queryList',
    method: 'post'
  }
}, {
  desc: '考勤详情',
  options: {
    url: '/salesAttendance/detail',
    method: 'post'
  }
}, {
  desc: '编辑保存考勤',
  options: {
    url: '/salesAttendance/save',
    method: 'post'
  }
}, {
  desc: '考勤导入',
  options: {
    url: '/salesAttendance/import',
    method: 'post'
  }
}]
export default salesAttendance



// WEBPACK FOOTER //
// ./src/api/salesAttendance.js